/**
 * NCND (No Elusión y No Divulgación) acceptance constants.
 *
 * The clause lives in the Terms of Service v1.3 (`@tago/legal`, section 10).
 * The acceptance record points at the same public URL the user can read, so
 * a `legal_acceptances` row stays a person, a wording, and a moment — the
 * same append-only pattern as the Qualitas AML disclaimer.
 */

/** Bump when the NCND wording changes — stored on each acceptance. */
export const NCND_DOCUMENT_VERSION = 'terms-ncnd-2026-09-06'

export const NCND_DOCUMENT_TYPE = 'terms_of_service_ncnd'

/** Public, readable source of the wording being accepted. */
export const NCND_DOCUMENT_URL = 'https://tago.rent/es/legal/terms-of-service'
